import Modal from './accessibility';
import Dom from '../Utility/Dom';

const _site_header = document.getElementById('header');
const nav_breakpoint = 1200;
localStorage.setItem('scrollthreshold', 0);
/* NAVIGATION SCROLLING */
function td_setHeader(lstate) {
    var viewportHeaderPercentage = .75;
    if(lstate == 'first') {
        if(window.pageYOffset < window.innerHeight * viewportHeaderPercentage) {
            _site_header.classList.add('activeHeader');
            _site_header.classList.remove('activeHeader__fill');
        } else {
            _site_header.classList.remove('activeHeader');
            _site_header.classList.add('activeHeader__fill');
        }
    } else {
        var currentScrollPos = window.pageYOffset;
        let threshold = parseFloat(localStorage.getItem('scrollthreshold'));
        // if (prevScrollpos > currentScrollPos || currentScrollPos == 0) {
        // show the nav
        if (prevScrollpos > currentScrollPos || currentScrollPos < 300) {
          if(window.pageYOffset < window.innerHeight * viewportHeaderPercentage) {
              // show nav at top of page
              _site_header.style.top = "0";
              _site_header.classList.add('activeHeader');
              _site_header.classList.remove('activeHeader__fill');
          } else {
              // show nav when scrolling back up page
              if(threshold >= 35) {
                  _site_header.style.top = "0";
                  _site_header.classList.remove('activeHeader');
                  _site_header.classList.add('activeHeader__fill');
              } else {
                  let newthreshold = threshold + 3;
                  localStorage.setItem('scrollthreshold', newthreshold);
              }
          }
        } else {
            // hide the nav
            _site_header.classList.remove('activeHeader');
            _site_header.classList.remove('activeHeader__fill');
          _site_header.style.top = "-150px";
          localStorage.setItem('scrollthreshold', 0);
        }
        prevScrollpos = currentScrollPos;
    }
}

function td_init_desktop_nav() {
    /* DESKTOP MODAL NAVIGATION */
    const menuModal   = $(Dom.menuModal);
    const menuTrigger = $(Dom.menuTrigger);
    const closeMenu   = $(Dom.closeMenu);
    const menuGroup   = $(Dom.menuGroup);
    const menuLinks   = $(Dom.menuLinks);
    const btnGroup    = $(Dom.btnGroup);
    const closeButton = $(Dom.closeMenuButton);
    const bodyElem    = $(Dom.body);

    Dom.menuLinks.on('click keypress', e => {
        // console.log('menu links');
        if($(window).width() >= nav_breakpoint) {
            e.preventDefault();
            if(e.type === 'click' || e.key === 'Enter' ){

                bodyElem.removeClass('nav-active');

                let ctarget = $(e.currentTarget);
                // if not open already we need to open the menu PANEL first
                menuModal.addClass('active').attr('aria-hidden', 'false').attr('tabindex','1');
                // Add animating class to prevent overflow:auto css showing a scroll bar while animating on windows os
                menuModal.addClass('animating');
                setTimeout(function(){
                    menuModal.removeClass('animating');
                },500);
                // remove active from other links
                menuLinks.removeClass('active');
                // add active class to this link
                ctarget.addClass('active');
                // remove active class on any open menus
                menuGroup.removeClass('active').attr('aria-hidden', 'true').attr('tabindex','-1');
                // get target menu container #block-menu-etc
                let target = ctarget.attr('menu-target');
                // $ add active classes to element
                $(`#${target}`).addClass('active').attr('aria-hidden', 'false').attr('tabindex','1')
                // lock the page container to prevent user scroll
                bodyElem.addClass('scroll-lock modal-nav-active');
                // Handles trapping focus in modal
                Modal.open(menuModal);

                // If link is search, set focus to search field
                if(ctarget.parent().hasClass('menu-item__search')){
                  menuModal.find('.search-field').focus();
                }
            }
        }
    });

    closeMenu.on('click keypress', e => {
        if(e.key === 'Enter' || e.type === 'click'){
            // apply closing class
            menuModal.addClass('menu-closing');

            // wait for animation, then close the menu
            setTimeout(function(){
                // remove body scroll lock capability
                bodyElem.removeClass('scroll-lock modal-nav-active');
                // get target element to close
                let target = $(e.currentTarget).data('target');
                // hide the menu overlay
                menuModal.removeClass('active').attr('aria-hidden', 'true').attr('tabindex','-1');
                // remove active class from any active menu link
                menuLinks.removeClass('active');
                // rmeove active class from any active menu panels
                menuGroup.removeClass('active').attr('aria-hidden', 'true').attr('tabindex','-1');
                // Handles un-trapping focus in modal
                Modal.close(menuModal);
            }, 300);

            setTimeout(function(){
                // remove closing class
                menuModal.removeClass('menu-closing');
            }, 900);


            if(e.key === 'Enter'){
                const dataTarget = target.split('#')[1];
                $(`[modal-target="${dataTarget}"]`).focus();
            }
        }
    });

    // Handles focus states
    btnGroup.focus((e) => { $(e.currentTarget).find(closeButton).addClass('hover-active') });
    btnGroup.focusout((e) => { $(e.currentTarget).find(closeButton).removeClass('hover-active') });

    btnGroup.hover(
        // On hover add this class
        (e) => { $(e.currentTarget).find(closeButton).addClass('hover-active'); },
        // on hover exit remove this class
        (e) => {
            $(e.currentTarget).find(closeButton).removeClass('hover-active');
        }
    )
}
/* When the user scrolls down, hide the navbar. When the user scrolls up, show the navbar */
var prevScrollpos = window.pageYOffset;

window.onscroll = function() {
  td_setHeader();
}


$(document).ready(() => {
    // MODAL

    td_setHeader('first');

    td_init_desktop_nav();

    // mobile navmenu

    // $('.menu-toggle').each(function() {
    //     $(this).on('click keypress', e => {
    //         e.preventDefault();
    //         if(e.type === 'click' || e.key === 'Enter' ){
    //             $('#site-navigation').addClass('active').attr('aria-hidden', 'false').attr('tabindex','1');
    //             $('body').addClass('scroll-lock nav-active');
    //         }
    //     });
    // });
});




/* MENU MOBILE NAV FUNCs */

var animEndEventNames = {

  'WebkitAnimation': 'webkitAnimationEnd',
  'OAnimation': 'oAnimationEnd',
  'msAnimation': 'MSAnimationEnd',
  'animation': 'animationend'

};

var animEndEventName = animEndEventNames[Modernizr.prefixed('animation')];


var $mainNav        = $('ul.main-navigation'),
    $mainNavTrigger = $('button.menu-toggle'),
    $subnav         = $('ul.main-dropdown'),
    $subnavTrigger  = $('a.has-dropdown-link'),
    $dropNav         = $('.main-navigation .td-inner-menu'),
    $dropNavTrigger = $('a.has-subnav-link'),
    _subNavHeaders  = $('.has-subnav-link.subnav-header'),
    _allSubnavLinks = $('.main-navigation a, .go-back a'),
    $subnavGoBack;
    $dropNav.slideUp();

var respListenClass     = 'from-small-vp';

enquire.register(`(max-width: ${nav_breakpoint - 1}px)`, {

  // Only insert the HTML when the MQ is matched
  // We'll hide/show it on resize to reduce performance hiccups
  setup: function() {
    $('body').addClass(respListenClass);

    // if($('body').hasClass('nav-active')) {
    //     $('body').addClass('scroll-lock');
    // }

    _subNavHeaders.attr('tabindex', 0);

    // turn off tabbing on initial page load
    $('.has-subnav .subnav a').attr('tabindex', -1);
    $('.go-back a').attr('tabindex', -1);

    // Toggle Nav
    $mainNavTrigger.on('click', function(e) {
     let $_body = $('body');
      $(this).toggleClass('active');
      if($_body.hasClass('nav-active') || $_body.hasClass('nav-m-active')) {
          $('#site-navigation').removeClass('active in-viewport').attr('aria-hidden', 'false').attr('tabindex','1');
          $_body.removeClass('scroll-lock nav-active nav-m-active');
      } else {
          $('#site-navigation').addClass('active in-viewport').attr('aria-hidden', 'false').attr('tabindex','1');
          $_body.addClass('scroll-lock nav-active');
      }

      $('.main-nav > li > a:first-child').focus();
      if (!$('.main-nav').is(':visible')) {

        $('.main-nav')
            .show()
            .addClass('active nav-in')
            .on(animEndEventName, function() {

              $(this)
                  .removeClass('nav-in')
                  .show();

            });
            $('.main-nav a').attr('tabindex', -1);
            $('.main-nav > li > a').attr('tabindex', 0);
      }
      else {

        $('.main-nav')
            .removeClass('active')
            .addClass('nav-out')
            .on(animEndEventName, function() {

              $(this)
                  .removeClass('nav-out')
                  .hide();

              resetNav();

            });

      }

    });

    // Add the 'Back & View all links'
    // It's done in setup so it only does it once it matches
    $subnavTrigger.each(function() {
      var tempa = document.createElement('a');
      var thisText = this.innerText;
      tempa.href = '#';
      tempa.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="30" viewBox="0 0 28 30"><g fill="none" fill-rule="evenodd" stroke="#FFF" stroke-width="2"><path d="M27.806 14.27H2.311M16.444 29L2 14.29 16.444 1"/></g></svg>';
      tempa.innerHTML += ' ' + thisText;
      tempa.classList = 'go-back-link';
      $subnavGoBack = document.createElement('li');
      $subnavGoBack.classList = 'go-back';
      $subnavGoBack.prepend(tempa);
      var trigger = $(this),
          viewAll = '',
          viewAllLoc = trigger.attr('href'),
          viewAllText = trigger.text();
      trigger.next($subnav).prepend($subnavGoBack);
      trigger.next($subnav).find('li:not(.go-back):first').before(viewAll);

    });


  },
  match: function() {
    if(!$('body').hasClass('nav-active')) {
        $subnav.addClass('is-hidden');
    }
    $dropNavTrigger.on('click', function(e) {
        let thisTarget = $(this).data('target');
        // if($(thisTarget).hasClass('td-inner-active') && !$(this).hasClass('no-link')) {
        //     // if already active, direct user to detail page
        //     // window.location.href = $(thisTarget).attr('href');
        // } else {
            // else, hide others and show clicked
            e.preventDefault();
            $(this).blur();
            if($(this).hasClass('active')) {
                // hide all
                $dropNav.slideUp();
                $('.td-inner-menu').removeClass('td-inner-active')
                    .find('[data-scroll]').removeClass('is-inview');
                $dropNavTrigger.removeClass('active');
            } else {
                // hide all and show this
                $dropNav.slideUp();
                $('.td-inner-menu').removeClass('td-inner-active')
                    .find('[data-scroll]').removeClass('is-inview');
                $dropNavTrigger.removeClass('active');
                $(this).addClass('active');
                $($(this).data('target')).slideDown().addClass('td-inner-active')
                    .find('[data-scroll]').addClass('is-inview');
            }
        // }
    });

    $subnavTrigger.off('click');
    $subnavTrigger.on('click', function(e) {
        // console.log('subnavtrigger');
      e.preventDefault();

      var selected = $(this);

      // Show subnavs if their trigger was clicked
      if (selected.next($subnav).hasClass('is-hidden')) {
        // Add Active class to parent then go to siblings and
        // hide their subnavs and remove active class from their
        // has-subnav-links
        _allSubnavLinks.attr('tabindex', -1);
        $('.subnav-active').removeClass('subnav-active');
        selected
            .addClass('selected')
            .next('.subnav')
            .removeClass('is-hidden')
            .end()
            .parent('.has-subnav')
            .parent('ul')
            .addClass('moves-in');
        // Add Active class to clicked link and show it's subnav
        selected
            .parent('.has-subnav')
            .addClass('subnav-active')
            .siblings('.has-subnav')
            .children('ul')
            .addClass('is-hidden')
            .end()
            .children('a')
            .removeClass('selected');
            // enable tabbing on this elem
            if ($(this).parent().hasClass('has-subnav')){
              $(this).closest('.has-subnav').find('> .subnav > li > a').attr('tabindex', 0);
            }else if($(this).parent().parent().hasClass('main-nav')){
              $(this).closest('.subnav').find('> li > a').attr('tabindex', 0);
            } else if ($(this).parent().hasClass('has-subnav')){
              $(this).parent().find('.subnav > a').attr('tabindex', 0);
            }

      }
      else {

        selected
            .removeClass('selected')
            .next('ul')
            .addClass('is-hidden')
            .end()
            .parent('.has-subnav')
            .parent('ul').removeClass('moves-in');

      }

    });

    // Go Back
    $('.go-back').on('click', function(e) {
      _allSubnavLinks.attr('tabindex', -1);
      $('.go-back a').attr('tabindex', -1);
      $('.subnav-active').removeClass('subnav-active');
      $(this).closest('.has-subnav').parent().children('li').children('a').attr('tabindex', 0);
      e.preventDefault();

      $(this)
          .parent('ul')
          .addClass('is-hidden')
          .parent('.has-subnav')
          .parent('ul')
          .removeClass('moves-in');

    });

  },
  unmatch: function() {
    $mainNav.show();
    resetNav();

    // $('.js-beer-finder').each(function() {
    //   $(this).addClass('modal-trigger').attr('href', '#beer-finder-modal');
    // });
    //

  },
  deferSetup: true

})
       .register(`(min-width: ${nav_breakpoint - 1}px)`, {

         match: function() {
         const menuModal   = $(Dom.menuModal);
         const menuTrigger = $(Dom.menuTrigger);
         const closeMenu   = $(Dom.closeMenu);
         const menuGroup   = $(Dom.menuGroup);
         const menuLinks   = $(Dom.menuLinks);
         const btnGroup    = $(Dom.btnGroup);
         const closeButton = $(Dom.closeMenuButton);
         const bodyElem    = $(Dom.body);

           if(bodyElem.hasClass(respListenClass)){
             _allSubnavLinks.attr('tabindex', 0);
              bodyElem.removeClass(respListenClass);
           }
           if(bodyElem.hasClass('scroll-lock') && !bodyElem.hasClass('modal-nav-active')){
               bodyElem.removeClass('scroll-lock');
           }
           if(bodyElem.hasClass('nav-active')){
               bodyElem.removeClass('nav-active');
               bodyElem.addClass('nav-m-active');
               $('.main-navigation.moves-in').removeClass('moves-in');
               $('.subnav-active').removeClass('.subnav-active');
           }
           _subNavHeaders.attr('tabindex', -1);

           $subnavTrigger.off('click');

           $subnavTrigger.on('click keypress', e => {
               // console.log('subnavtrigger 2');

                   e.preventDefault();
               if(e.type === 'click' || e.key === 'Enter' ){
                   let ctarget = $(e.currentTarget);
                   // if not open already we need to open the menu PANEL first
                   menuModal.addClass('active').attr('aria-hidden', 'false').attr('tabindex','1');
                   // remove active from other links
                   menuLinks.removeClass('active');
                   // add active class to this link
                   ctarget.addClass('active');
                   // remove active class on any open menus
                   menuGroup.removeClass('active in-viewport').attr('aria-hidden', 'true').attr('tabindex','-1');
                   // get target menu container #block-menu-etc
                   let target = ctarget.attr('menu-target');
                   // $ add active classes to element
                   $(`#${target}`).addClass('active in-viewport').attr('aria-hidden', 'false').attr('tabindex','1')
                   // lock the page container to prevent user scroll
                   bodyElem.addClass('scroll-lock modal-nav-active');
                   // Handles trapping focus in modal
                   Modal.open(menuModal);
               }
           });
           // Probably do this once on setup instead of every match/unmatch
           $('.main-dropdown').each(function() {

             var subnav = $(this).find('[data-nav]'),
                 navCol = $(this).find('[data-col]');

             // iterates over X number of times navCol appears
             navCol.each(function() {

               var colNum = $(this).data('col').toString();

               $(this)
                   .children('.nav')
                   .append($(this).siblings('[data-nav=\"' + colNum + '\"]'));

             });

           });
           /* AA keyboard */
           $('.main-nav > li > a').on({
             'focus' : function() {
               $('.has-subnav').removeClass('hover');
             }
           });

           $('.has-subnav-link').on({
             // Mouse Enter
             'focus' : function() {
             $(this).closest('.has-subnav').addClass('hover');
               setTimeout(function() {
                 $(this).closest('.has-subnav').find('a:first-child').focus();
               }, 500);
             }
           });
           /* end AA keyboard */

           $('.main-nav > li.has-subnav').hover(
               // Mouse Enter
               function() {

                 $(this).addClass('hover');

               },
               // Mouse Leave
               function() {

                 $(this).removeClass('hover');

               }
           );

           $('.main-nav > li.has-subnav > a').on({

             'touchstart': function(e) {

               $('.main-nav > li.has-subnav').removeClass('hover');

               $(this).parent().addClass('hover');

               $('body').on({

                 'touchstart': function() {
                   if($(e.target).closest('.subnav').length || $(e.target).hasClass('subnav') || $(e.target).hasClass('has-subnav-link')) {
                     // do nothing
                   } else {
                     $('li.has-subnav').removeClass('hover');
                   }

                 }

               });

               return false;

             }

           });

           $('.subnav').removeClass('is-hidden');

         },
         unmatch: function() {

           $('.main-nav > li.has-subnav').off('mouseenter mouseleave');
           $('.main-nav > li.has-subnav > a').off('touchstart');

           $('.main-nav').hide();

           // Go through each dropdown and take the subnavs out
           // of the nav-col's to get the mobile menu
           $('.main-dropdown').each(function() {

             var subnav = $(this).find('[data-nav]');

             $(this).find('.nav-col:last').after(subnav);

           });

         }

       });

function resetNav() {
    $('.has-subnav-link').removeClass('selected');
    $('.has-subnav').removeClass('subnav-active');
    $('.main-nav-wrap').find('ul.moves-in').removeClass('moves-in');
    $('.subnav').addClass('is-hidden');
}
